import { v4 as uuid } from 'uuid'
import defaultTo from 'lodash/defaultTo'

import store from '@/store'
import { REGISTER_NOTIFICATION } from '@/store/modules/notification/types'

export const DEFAULT_NOTIFICATION_DURATION = 6 * 1000 // 6 secondes
export const IN_BETWEEN_NOTIFICATION_DELAY = 3 * 1000 // 3 secondes

/**
 * @param {VvNotification} notification
 * @returns {VvNotification}
 */
export function addNotification(notification) {
  store.dispatch(REGISTER_NOTIFICATION, notification)
}

/**
 * @param {{
 *  title: string,
 *  message: string,
 *  image?: string,
 *  cancellable?: boolean,
 *  duration?: number
 * }} payload
 * @returns {VvNotification}
 */
export function Notification({ cancellable, title, message, duration, image }) {
  return {
    id: uuid(),
    seen: false,
    triggerDate: new Date().toISOString(),
    toast: {
      shown: false,
      cancellable: defaultTo(cancellable, true),
      data: {
        message,
        title,
        image: defaultTo(image, null)
      },
      duration: defaultTo(duration, DEFAULT_NOTIFICATION_DURATION)
    }
  }
}

/**
 * @param {{
 *  title: string,
 *  message: string,
 *  image?: string,
 *  cancellable?: boolean,
 *  duration?: number
 * }} payload
 * @returns {VvNotificationBadge}
 */
export function NotificationBadge({ cancellable, title, message, duration, image, badgeId }) {
  return Object.assign(Notification({ cancellable, title, message, duration, image }), {
    payload: { badgeId }
  })
}
